<template>
  <div class="card card-default">
    <div class="card-header">Audit Log</div>
    <div class="table-responsive">
      <table class="table table-valign-middle mb-0">
        <thead>
          <tr>
            <th class="align-middle">Event</th>
            <th class="align-middle">Type</th>
            <th class="align-middle">Timestamp</th>
            <th class="align-middle">More Info</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="{ event, ip_address, message, type, user_agent, created_at } in formattedAudits">
            <td>{{ labelizeGeneral(event) }}</td>
            <td>
              <span> {{ type ? labelizeGeneral(type) : '' }} </span>
            </td>
            <td>
              {{ created_at }}
            </td>
            <td class="td-fit">
              <a class="btn btn-outline-primary fa fa-info-circle" v-if="message" href="#" tabindex="0" role="button"
                data-toggle="popover" data-trigger="focus" data-placement="bottom" data-html="true" title="Details"
                :data-content="message" @click.prevent>
              </a>
              <div v-else></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-md-12 mt-3">
      <pagination :current_page="page" :last_page="lastPage" :num_items="numItems" :num_total="total"> </pagination>
    </div>
  </div>
</template>
  
<script>
import SurveysService from '../../services/surveys-service';
import TeamsService from '../../services/teams-service';
export default {
  data() {
    return {
      audits: [],
      page: 1,
      lastPage: 1,
      total: 0,
      numItems: 0,
    };
  },
  mounted() {
    self = this;
    Bus.$on('sparkHashChanged', function (hash, parameters) {
      if (hash == "audit_survey") {
        self.indexAudits();
      }
    });

    self.$on('change-page', (index) => {
      self.changePage(index);
    });
  },
  computed: {
    formattedAudits() {
      return this.audits.map((audit) => {
        if (audit.userId) {
          return {
            ...audit,
            message: 'Initiator: ' + Spark.state.currentTeam.users.find(usr => usr.id == audit.userId).name
          };
        }
        return audit;
      });
    },
  },
  methods: {
    ucFirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    async indexAudits() {
      const teamId = Spark.state.currentTeam.id;
      const response = await SurveysService.settings.indexAudits(teamId, this.page);

      this.audits = response.data;
      this.page = response.currentPage;
      this.lastPage = response.lastPage;
      this.total = response.total;
      this.numItems = response.to;
      this.$nextTick(function () {
        $('[data-toggle="tooltip"]').tooltip();
        $('[data-toggle="popover"]').popover();
      });
    },
    changePage(page) {
      if (page === 0) return;

      this.page = page;
      this.indexAudits();
    },
  },
};
</script>
  